import React from 'react';
import { LabelList as StyledLabelList, LabelItem } from '../../styles/LabelPicker.styles';
import styled from 'styled-components';
import EditIcon from '../icons/EditIcon';

const EditButton = styled.button`
    background: none;
    border: none;
    color: #fff;
    cursor: pointer;
    font-size: 12px;
    margin-left: 8px;
    padding: 0 4px;
    border-radius: 3px;
    display: flex;
    align-items: center;
    &:hover {
        background: rgba(255, 255, 255, 0.2);
    }
`;

const LabelContent = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

const IconsContainer = styled.div`
    display: flex;
    align-items: center;
`;

const CheckMark = styled.span`
    margin-right: 8px;
`;

const LabelList = ({ labels, selectedLabels, onToggleLabel, isEditing, onEditLabel }) => (
    <StyledLabelList>
        {labels.map(label => (
            <LabelItem
                key={label.id}
                color={label.color}
                onClick={() => !isEditing && onToggleLabel(label.id)}
            >
                <LabelContent>
                    <span>{label.title}</span>
                    <IconsContainer>
                        {selectedLabels?.includes(label.id) && <CheckMark>✓</CheckMark>}
                        {onEditLabel && (
                            <EditButton onClick={(e) => {
                                e.stopPropagation();
                                onEditLabel(label);
                            }}>
                                <EditIcon />
                            </EditButton>
                        )}
                    </IconsContainer>
                </LabelContent>
            </LabelItem>
        ))}
    </StyledLabelList>
);

export default LabelList;
